'use strict';

import Vue from 'vue/dist/vue.common.js';
import VueResource from 'vue-resource';
import Store from '../vuex/store';

Vue.use(VueResource);

const endpoint = '/graphql';

export default {

  post (query) {
    Vue.http.interceptors.push( (request, next) => {
      request.headers.set('X-CSRF-TOKEN', Store.state.csrfToken);
      next();
    });

    return Vue.http.post(endpoint, {query: query})
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error));
  },

};



// WEBPACK FOOTER //
// ./app/javascript/vue/services/graphql.js